import { render, staticRenderFns } from "./chartPieBox.vue?vue&type=template&id=595d5cde&scoped=true&"
import script from "./chartPieBox.vue?vue&type=script&lang=js&"
export * from "./chartPieBox.vue?vue&type=script&lang=js&"
import style0 from "./chartPieBox.vue?vue&type=style&index=0&id=595d5cde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d5cde",
  null
  
)

export default component.exports